import { formatPhoneNumberIntl } from 'react-phone-number-input';

export const formatPhoneNumber = phoneNumber => {
  const phone = formatPhoneNumberIntl(phoneNumber);
  // Remove all spaces except first, which separates the country number
  // This is done to match phone number validation RegExp on backend
  return phone.replace(/\s/g, (i => m => (!i++ ? m : ''))(0));
};
